/** A trackpad pinch reaches the page as ctrl+wheel, or as Safari's gesture events. */
const CANVAS_SELECTOR = '#canvas';
const GESTURE_EVENTS = ['gesturestart', 'gesturechange', 'gestureend'];

export function isPinchOnCanvas(target: EventTarget | null): boolean {
  return target instanceof Element && !!target.closest(CANVAS_SELECTOR);
}

/** Off the canvas a pinch scales the whole window, which users cannot undo. */
export function installPinchZoomGuard(root: Document = document): () => void {
  const swallowOffCanvas = (event: Event) => {
    if (isPinchOnCanvas(event.target)) return;
    event.preventDefault();
  };

  const onWheel = (event: WheelEvent) => {
    if (!event.ctrlKey) return;
    swallowOffCanvas(event);
  };

  root.addEventListener('wheel', onWheel, {passive: false});
  for (const name of GESTURE_EVENTS) {
    root.addEventListener(name, swallowOffCanvas, {passive: false});
  }

  return () => {
    root.removeEventListener('wheel', onWheel);
    for (const name of GESTURE_EVENTS) {
      root.removeEventListener(name, swallowOffCanvas);
    }
  };
}
